// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Client from "@apollo/client";
import * as PromotionRoutes from "./PromotionRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PromotionStatusBadge from "../../modules/Promotion/PromotionStatusBadge.res.js";
import * as PromotionTableMoreActionsMenu from "../../modules/Promotion/PromotionTableMoreActionsMenu.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query PromotionListPageQuery($first: Int, $last: Int, $before: String, $after: String, $search: String, $filterBy: InputPromotionCampaignsQueryFilter)  {\npromotionCampaignsDistinctOnCku(filterBy: $filterBy, search: $search, first: $first, last: $last, before: $before, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \nname  \nstartDate  \nendDate  \ndiscounts  {\n__typename  \ntotalCount  \n}\n\nformattedShopsNames  \nprice  {\n__typename  \nname  \n}\n\nformattedStatus  \n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.promotionCampaignsDistinctOnCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    promotionCampaignsDistinctOnCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.discounts;
        let value$3 = value$1.price;
        let value$4 = value$1.formattedStatus;
        let tmp;
        switch (value$4) {
          case "ARCHIVED" :
            tmp = "ARCHIVED";
            break;
          case "DRAFT" :
            tmp = "DRAFT";
            break;
          case "EXPIRED" :
            tmp = "EXPIRED";
            break;
          case "NOT_PROGRAMMED" :
            tmp = "NOT_PROGRAMMED";
            break;
          case "ONGOING" :
            tmp = "ONGOING";
            break;
          case "PROGRAMMED" :
            tmp = "PROGRAMMED";
            break;
          case "STOPPED" :
            tmp = "STOPPED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            name: value$1.name,
            startDate: Scalar.Datetime.parse(value$1.startDate),
            endDate: Scalar.Datetime.parse(value$1.endDate),
            discounts: {
              __typename: value$2.__typename,
              totalCount: value$2.totalCount
            },
            formattedShopsNames: value$1.formattedShopsNames,
            price: {
              __typename: value$3.__typename,
              name: value$3.name
            },
            formattedStatus: tmp
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.promotionCampaignsDistinctOnCku;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedStatus;
    let formattedStatus = value$2 === "STOPPED" ? "STOPPED" : (
        value$2 === "ARCHIVED" ? "ARCHIVED" : (
            value$2 === "DRAFT" ? "DRAFT" : (
                value$2 === "NOT_PROGRAMMED" ? "NOT_PROGRAMMED" : (
                    value$2 === "ONGOING" ? "ONGOING" : (
                        value$2 === "EXPIRED" ? "EXPIRED" : "PROGRAMMED"
                      )
                  )
              )
          )
      );
    let value$3 = value$1.price;
    let value$4 = value$3.name;
    let value$5 = value$3.__typename;
    let price = {
      __typename: value$5,
      name: value$4
    };
    let value$6 = value$1.formattedShopsNames;
    let value$7 = value$1.discounts;
    let value$8 = value$7.totalCount;
    let value$9 = value$7.__typename;
    let discounts = {
      __typename: value$9,
      totalCount: value$8
    };
    let value$10 = value$1.endDate;
    let value$11 = Scalar.Datetime.serialize(value$10);
    let value$12 = value$1.startDate;
    let value$13 = Scalar.Datetime.serialize(value$12);
    let value$14 = value$1.name;
    let value$15 = value$1.cku;
    let value$16 = Scalar.CKU.serialize(value$15);
    let value$17 = value$1.id;
    let value$18 = value$1.__typename;
    let node = {
      __typename: value$18,
      id: value$17,
      cku: value$16,
      name: value$14,
      startDate: value$13,
      endDate: value$11,
      discounts: discounts,
      formattedShopsNames: value$6,
      price: price,
      formattedStatus: formattedStatus
    };
    let value$19 = value.__typename;
    return {
      __typename: value$19,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let promotionCampaignsDistinctOnCku = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    promotionCampaignsDistinctOnCku: promotionCampaignsDistinctOnCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputPromotionCampaignsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.last;
  let a$2 = inp.before;
  let a$3 = inp.after;
  let a$4 = inp.search;
  let a$5 = inp.filterBy;
  return {
    first: a !== undefined ? a : undefined,
    last: a$1 !== undefined ? a$1 : undefined,
    before: a$2 !== undefined ? a$2 : undefined,
    after: a$3 !== undefined ? a$3 : undefined,
    search: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputPromotionCampaignsQueryFilter(a$5) : undefined
  };
}

function makeVariables(first, last, before, after, search, filterBy) {
  return {
    first: first,
    last: last,
    before: before,
    after: after,
    search: search,
    filterBy: filterBy
  };
}

function makeInputObjectInputPromotionCampaignsQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    first: undefined,
    last: undefined,
    before: undefined,
    after: undefined,
    search: undefined,
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPromotionCampaignsQueryFilter: serializeInputObjectInputPromotionCampaignsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPromotionCampaignsQueryFilter: makeInputObjectInputPromotionCampaignsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPromotionCampaignsQueryFilter: serializeInputObjectInputPromotionCampaignsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPromotionCampaignsQueryFilter: makeInputObjectInputPromotionCampaignsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function encoder(param) {
  return Stdlib_Option.map(param.shop, shop => shop.id);
}

function decoder(shops, shopId) {
  return {
    TAG: "Ok",
    _0: {
      shop: shops.find(shop => shop.id === shopId)
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object1(encoder, arg => decoder(shops, arg), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)));
}

let Filters = {
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let Row = {};

function makeQueryVariables(_defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    first: connectionArguments.first,
    last: connectionArguments.last,
    before: connectionArguments.before,
    after: connectionArguments.after,
    search: search,
    filterBy: filterBy
  };
}

function makeQueryVariablesFilterBy(param) {
  let shop = param.shop;
  return {
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined,
    archived: "EXCLUDED"
  };
}

function totalCountFromQueryData(param) {
  return param.promotionCampaignsDistinctOnCku.totalCount;
}

function cursorsFromQueryData(param) {
  let promotionCampaignsDistinctOnCku = param.promotionCampaignsDistinctOnCku;
  return [
    promotionCampaignsDistinctOnCku.pageInfo.startCursor,
    promotionCampaignsDistinctOnCku.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return param.promotionCampaignsDistinctOnCku.edges.map(edge => ({
    cku: edge.node.cku,
    id: edge.node.id,
    name: edge.node.name,
    startDate: edge.node.startDate,
    endDate: edge.node.endDate,
    discountsCount: edge.node.discounts.totalCount,
    priceName: edge.node.price.name,
    formattedShopsNames: edge.node.formattedShopsNames,
    formattedStatus: edge.node.formattedStatus
  }));
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

let scaffoldedColumns = [
  {
    name: I18n.t("Name"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 200
      },
      width: {
        NAME: "pct",
        VAL: 20
      },
      sticky: true
    },
    render: param => JsxRuntime.jsx(TextLink.make, {
      text: param.name,
      to: {
        TAG: "Route",
        _0: PromotionRoutes.showRoute(param.cku)
      }
    })
  },
  {
    name: I18n.t("Start date"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, param.startDate)
    })
  },
  {
    name: I18n.t("End date"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 110
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, param.endDate)
    })
  },
  {
    name: I18n.t("Discounted products"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 60
      },
      width: {
        NAME: "px",
        VAL: 170
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.discountsCount.toString()
    })
  },
  {
    name: I18n.t("Price list"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.priceName
    })
  },
  {
    name: I18n.t("Active shops"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.formattedShopsNames
    })
  },
  {
    name: I18n.t("Status"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 90
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    render: param => JsxRuntime.jsx(PromotionStatusBadge.make, {
      status: param.formattedStatus
    })
  },
  {
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 70
      },
      width: {
        NAME: "px",
        VAL: 70
      },
      alignX: "flexEnd",
      sticky: true
    },
    render: param => {
      let notifier = Notifier.use(undefined, undefined);
      return JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsx(PromotionTableMoreActionsMenu.make, {
          cku: param.cku,
          id: param.id,
          name: param.name,
          startDate: param.startDate,
          notifier: notifier
        }),
        right: -2,
        width: 32,
        height: 32
      });
    }
  }
];

function PromotionListPage(props) {
  let authorizedCreateRoute = props.authorizedCreateRoute;
  let notifier = Notifier.use(undefined, undefined);
  let scope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let initialFilters = {
    shop: activeShop
  };
  let initialState = Scaffolded.makeInitialState(initialFilters);
  let match = Scaffolded.use(() => initialState);
  let dispatch = match[1];
  let state = match[0];
  let defaultQueryVariables = {
    first: undefined,
    last: undefined,
    before: undefined,
    after: undefined,
    search: undefined,
    filterBy: undefined
  };
  let filters;
  filters = scope.TAG === "Organisation" ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
      value: state.filters.shop,
      onChange: shop => dispatch({
        TAG: "FiltersUpdated",
        _0: param => ({
          shop: shop
        })
      })
    }) : null;
  let actions;
  actions = authorizedCreateRoute.TAG === "Ok" ? JsxRuntime.jsx(Button.make, {
      label: I18n.t("New campaign"),
      variant: "solid",
      tone: "brand",
      size: "legacy_large",
      href: authorizedCreateRoute._0
    }) : null;
  let emptyState;
  let exit = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined || state.filters.shop !== activeShop) {
    exit = 1;
  } else {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.create,
      title: I18n.t("Welcome to the promotional campaigns space."),
      text: Stdlib_Result.isOk(authorizedCreateRoute) ? I18n.t("Start creating your first campaign.") : undefined,
      children: actions
    });
  }
  if (exit === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  let banner = JsxRuntime.jsx(Notifier.Banner.make, {
    notifier: notifier
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search a campaign"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Promotional campaigns"),
    state: state,
    dispatch: dispatch,
    columns: scaffoldedColumns,
    filters: filters,
    actions: actions,
    banner: banner,
    searchBar: searchBar,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make = React.memo(PromotionListPage);

export {
  Query,
  Filters,
  Row,
  Scaffolded,
  scaffoldedColumns,
  make,
}
/* query Not a pure module */
